var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wrapped-image',{staticClass:"background-image",attrs:{"alt":_vm.alt,"fallback-image":_vm.fallbackImage,"image-classes":_vm.imageClasses,"sizes":_vm.sizes,"src":_vm.src,"srcset":_vm.srcset,"width":_vm.width,"with-gradient":_vm.withGradient}})
}
var staticRenderFns = []

export { render, staticRenderFns }